import { gql } from 'apollo-boost'

export const DELETE_ORDERGROUP = gql`
mutation DeleteOrderGroup($where: OrderGroupWhereInputOne!) {
    deleteOrderGroup(where: $where) {
      id
    }
  }
`

export const UPDATE_ORDER_GROUP = gql`
mutation UpdateOrderGroup($where: OrderGroupWhereInputOne!, $data: OrderGroupInput) {
  updateOrderGroup(where: $where, data: $data) {
    id
  }
}
`

export const UPDATE_ORDER_GROUP_V2 = gql`
mutation UpdateOrderGroupV2($where: OrderGroupWhereInputOne!, $data: OrderGroupInput) {
  updateOrderGroupV2(where: $where, data: $data) {
    id
  }
}
`

export const RETURN_ORDER_GROUP = gql`
mutation ReturnOrderGroup($where: OrderGroupWhereInputOne!) {
  returnOrderGroup(where: $where) {
    id
  }
}
`

export const UPDATE_PAID = gql`
mutation UpdatePaid($where: OrderGroupWhereInputOne!, $data: OrderGroupInput) {
  updatePaid(where: $where, data: $data) {
    id
    status
  }
}
`
export const UPDATE_PAID_V2 = gql`
mutation UpdatePaidV2($where: OrderGroupWhereInputOne!, $data: OrderGroupInput) {
  updatePaidV2(where: $where, data: $data) {
    id
    status
  }
}
`

export const UPDATE_ORDER_GROUP_DETAIL = gql`
mutation UpdateOrderGroupDetail($where: OrderGroupWhereInputOne!, $data: OrderGroupInput) {
  updateOrderGroupDetail(where: $where, data: $data) {
    status
    msg
    tag
    orderGroup {
      checkBillDate
      code
      id
      amount
      sumPrice
    }
  }
}
`